import { z } from 'zod';

export const GcrCombinationSchema = z.object({
  typeId: z.string().min(1, 'Model type is required'),
  sizeId: z.string().min(1, 'Size is required'),
});

export const GcrFormSchema = z.object({
  filePublicUrl: z.union([z.string(), z.instanceof(File)]).optional(),
  name: z
    .string()
    .min(3, 'Gcr name must be at least 3 characters long')
    .max(100, 'Gcr name cannot exceed 100 characters'),
  colorId: z.string().min(1, 'Color is required'),
  printerId: z.string().min(1, 'Printer is required'),
  combinations: z
    .array(GcrCombinationSchema)
    .superRefine((combinations, ctx) => {
      const seen = new Set<string>();

      combinations.forEach((combination, index) => {
        const key = `${combination.typeId}_${combination.sizeId}`;

        if (seen.has(key)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Duplicate model type and size combination',
            path: [index, 'sizeId'],
          });
        }

        seen.add(key);
      });
    }),
});

export type GcrFormValues = z.infer<typeof GcrFormSchema>;
